import { render } from "./ChatMediaUploadOptions.vue?vue&type=template&id=bb7c324a"
import script from "./ChatMediaUploadOptions.vue?vue&type=script&lang=js"
export * from "./ChatMediaUploadOptions.vue?vue&type=script&lang=js"
script.render = render

export default script